import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(public auth: AuthService, public router: Router){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (state.url.includes('dashboard-smart-tv')) {
            return true;
        }

        if (!this.auth.isAuthenticated()){
            this.router.navigate(['login']);
            return false;
        }

        return true;
    }
}